module.exports = __webpack_public_path__ + "static/home1-facebook-like-page-e3b7a46c07786cc356777b18ae85e125.jpg";